import AppBar from '@/components/page/appBar'
import Footer from '@/components/page/footer'
import React, { FunctionComponent } from 'react'

interface Prop {
  token?: string
}
const MainLayout: FunctionComponent<React.PropsWithChildren<Prop>> = (props) => {
  return (
    <div className='bg-surfaceLow'>
      <AppBar />
      <div className='pt-28'>
        {props.children}
      </div>
      <Footer />
    </div>

  )
}

export default MainLayout
